<template>
  <CCol>
    <!-- <CRow>
      <CCol sm="12" class="text-white">
        <h1 class="mb-5">{{ $t('auth.newRegister.aside.header1.with-arpoone') }} </h1>
        <ul class="p-0">
          <li class="d-flex align-items-center mb-4">
            <i class="cil-check-alt icon-custom-size text-primary mr-3 h4"></i>
            <p class="mb-0 font-xl text-gray-700">{{$t('auth.newRegister.aside.text.import-contact')}}</p>
          </li>
          <li class="d-flex align-items-center mb-4">
            <i class="cil-check-alt icon-custom-size text-primary mr-3 h4"></i>
            <p class="mb-0 font-xl text-gray-700">
              {{$t('auth.newRegister.aside.text.create-audience')}}
            </p>
          </li>
          <li class="d-flex align-items-center mb-4">
            <i class="cil-check-alt icon-custom-size text-primary mr-3 h4"></i>
            <p class="mb-0 font-xl text-gray-700">
              {{$t('auth.newRegister.aside.text.send-personalized')}}
            </p>
          </li>
          <li class="d-flex align-items-center mb-4">
            <i class="cil-check-alt icon-custom-size text-primary mr-3 h4"></i>
            <p class="mb-0 font-xl text-gray-700">
              {{$t('auth.newRegister.aside.text.build-simple')}}
            </p>
          </li>
          <li class="d-flex align-items-center mb-4">
            <i class="cil-check-alt icon-custom-size text-primary mr-3 h4"></i>
            <p class="mb-0 font-xl text-gray-700">
              {{$t('auth.newRegister.aside.text.create-beautiful')}}
            </p>
          </li>
          <li class="d-flex align-items-center mb-4">
            <i class="cil-check-alt icon-custom-size text-primary mr-3 h4"></i>
            <p class="mb-0 font-xl text-gray-700">
              {{$t('auth.newRegister.aside.text.understand-audience')}}
            </p>
          </li>
        </ul>
      </CCol>
    </CRow>
    <Steps :steps="3" :stepActive="1" :progress="25"/> -->
  </CCol>
</template>

<script>
import Steps from '@/views/auth/components/aside/Steps.vue'

export default {
  name: 'AsideNewRegister',
  components: {
    Steps,
  },
}
</script>

<style></style>
